import { pipe, skip, distinctUntilChanged, tap, finalize } from 'rxjs';
import { map } from 'rxjs/operators';
import { isEqual } from 'lodash-es';

function includeKeys(a){return pipe(map(b=>Object.keys(b).reduce((c,d)=>(a.includes(d)&&(c[d]=b[d]),c),{})))}

function syncState(a,b){const c={channel:`${a.name}@store`,source:a=>a.asObservable(),preUpdate:a=>a.data,runGuard:()=>"undefined"!=typeof window&&"undefined"!=typeof window.BroadcastChannel},d=Object.assign(Object.assign({},c),b);if(!d.runGuard())return;const e=new BroadcastChannel(d.channel);let f=!0;return e.addEventListener("message",b=>{const c=d.preUpdate(b);f=!1,a.update(a=>Object.assign(Object.assign({},a),c));}),d.source(a).pipe(skip(1),distinctUntilChanged(isEqual),tap(a=>{f?e.postMessage(a):f=!0;}),finalize(()=>e.close())).subscribe(),e}

export { includeKeys, syncState };
